/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description It converts a given objects into url query parameters. Used when downloading a csv file
 * @param object
 * @returns {string}
 */

export const buildQueryParams = (obj, prefix = '') => {
  const params = [];

  Object.entries(obj).forEach(([key, value]) => {
    const paramKey = prefix ? `${prefix}[${key}]` : key;

    if (Array.isArray(value)) {
      value.forEach(v => {
        params.push(`${paramKey}[]=${encodeURIComponent(v)}`);
      });
    } else if (typeof value === 'object' && value !== null) {
      params.push(buildQueryParams(value, paramKey));
    } else if (value !== undefined && value !== null) {
      params.push(`${paramKey}=${encodeURIComponent(value)}`);
    }
  });

  return params.join('&');
};
